import { withRouter, Link } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import React, { useEffect, useState } from "react";
import facilityService from "../services/facility-service";
import { selectUsers } from "../state/reducers/userSlice";
import AMI_T from "../assets/img/AMI_T.png";

const Dashboard = ({ history }) => {
  const { user } = useSelector(selectUsers);

  const [access, setAccess] = useState({});
  const getAccessForFacility = async () => {
    try {
      let resp = await facilityService.getAccessForFacilities(user?.facility);
      setAccess(resp);
    } catch (e) {
     
    }
  };
  useEffect(() => {
    if (user?.userType === "EXTERNAL") {
      getAccessForFacility();
    }
  }, [user, history]);
  return (
    <>
      <CipHeader />
      <div className="w-full flex">
        <div className={`w-full text-center px-0 md:px-60 `}>
          <div className={`${ user?.userType === "EXTERNAL" && (access?.add_patient === "T" || access?.new_order === "T" || access?.batch_refill === "T"|| access?.delivery_recon === "T") ? 'w-2/3 h-5/6' : 'w-1/2 h-5/6'}  block ml-auto mr-auto `}>
            <img alt="" className="flex w-full h-full" src={AMI_T} />
          </div>
          <p className="text-sm text-dasbrTxtColor font-normal">
          Hi! I’m Clinical Solution’s Automated Medication Interface, but you can just call me AMI! I’ve been created specifically to help make all your pharmacy needs easier and more efficient! I am excited to be able to provide you with a simple to use, one-stop location where you can order new medications, refill or stop any existing ones, check in your orders, print MARs, and overall manage your medications more effectively.
          </p>
        </div>
        {user?.userType === "EXTERNAL" && user?.userRole !== "EMAR_USER"&& user?.userRole !== "PROVIDER"&& (
          <div className="w-1/4 justify-end flex">
            <div className=" border-2 py-4 my-8 mx-8 bg-white rounded  border-solid">
              <div className="w-full text-darkclr font-semibold leading-6 px-4 ">
                <span className="text-xl">Quick Links</span>
              </div>
              <ul className="text-left mt-4">
              {access?.add_patient === "T" && (    <li>
                  <Link
                    to="/createPatient"
                    className=" bg-header_bg rounded mb-2 mx-4 py-1 px-2  cursor-pointer text-sm  text-white  inline-block shadow-md leading-6"
                  >
                    Add Patient
                  </Link>
                </li>
                )}
                {access?.new_order === "T" && (
                  <li>
                    <Link
                      to="/createOrder"
                      className=" bg-header_bg rounded mb-2 mx-4 py-1 px-2  cursor-pointer text-sm  text-white  inline-block shadow-md leading-6"
                    >
                      New Order
                    </Link>
                  </li>
                )}
                {access?.batch_refill === "T" && (
                  <li>
                    <Link
                      to="/refill"
                      className=" bg-header_bg rounded mb-2 mx-4 py-1 px-2  cursor-pointer text-sm  text-white  inline-block shadow-md leading-6"
                    >
                      Batch Refill
                    </Link>
                  </li>
                )}
                {access?.delivery_recon === "T" && (
                  <li>
                    <Link
                      to="/delivery"
                      className=" bg-header_bg rounded mb-2 mx-4 py-1 px-2  cursor-pointer text-sm  text-white  inline-block shadow-md leading-6"
                    >
                      Delivery Reconciliation
                    </Link>
                  </li>
                )}
                
                  <li>
                    <Link
                      to="/patientDetails"
                      className=" bg-header_bg rounded mb-2 mx-4 py-1 px-2  cursor-pointer text-sm  text-white  inline-block shadow-md leading-6"
                    >
                      Patient Medications
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/patients"
                      className=" bg-header_bg rounded mb-2 mx-4 py-1 px-2  cursor-pointer text-sm  text-white  inline-block shadow-md leading-6"
                    >
                      Patient List
                    </Link>
                  </li>
                
              </ul>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(Dashboard)
);
